import { useSession } from "@src/appV2/Auth/api/useSession";
import { useIsAdmin } from "@src/appV2/ExperimentalHomeHealth/lib/useIsAdmin";

export function useWorkplaceIds() {
  const session = useSession();
  const isAdmin = useIsAdmin();

  const workplaceId = session.type === "FACILITY" ? session.userId : undefined;
  const workplaceUserId = session.type === "FACILITY" && !isAdmin ? session.user?._id : undefined;
  const sessionUserId = session.user?._id ?? "";

  return {
    workplaceId,
    workplaceUserId,
    sessionUserId,
    isAdmin,
  };
}
